import { render, staticRenderFns } from "./Leads.vue?vue&type=template&id=6a16e6a9&scoped=true"
import script from "./Leads.vue?vue&type=script&lang=js"
export * from "./Leads.vue?vue&type=script&lang=js"
import style0 from "./Leads.vue?vue&type=style&index=0&id=6a16e6a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a16e6a9",
  null
  
)

export default component.exports